module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAXklEQVQ4jWNgGBTgP5kAbkDD7MMkawbpQTjBvP0/KYaANQP1oBiAzZBfj9zBGKtmbAYQcgmKZlwGIBty2z/h/22/eOya8RkAM+TzkVNgjFUzIQNAGAZwyQ8rA4Y0AAAk9qNu6B0iIgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/MF.png
// module id = 1204
// module chunks = 0